import { render } from "./associated-account.vue?vue&type=template&id=633213de&scoped=true"
import script from "./associated-account.vue?vue&type=script&lang=js"
export * from "./associated-account.vue?vue&type=script&lang=js"

import "./associated-account.vue?vue&type=style&index=0&id=633213de&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633213de"]])

export default __exports__